__turbopack_context__.v({
  "contact_content": "contact_form-module__dZCVvG__contact_content",
  "contact_content_form_textarea": "contact_form-module__dZCVvG__contact_content_form_textarea",
});
